// extracted by mini-css-extract-plugin
export default {"button":"TransparentButton_button__hBSlJ"};